
import './Spinner.css';

function Spinner () {
    return(
        <div className='flex justify-center items-center h-screen'>
            <div className="custom-loader"></div>
        </div>
    );
}

export default Spinner;